import React, { useState, useEffect, useRef } from 'react';
import {Image, Skeleton} from '@mantine/core';

interface ImageWithSkeletonProps {
    src: string | undefined;
    alt: string;
    onClick: () => void;
}

const ImageWithSkeleton = React.memo(({ src, alt, onClick }: ImageWithSkeletonProps) => {
    const [loaded, setLoaded] = useState(false);
    const imgRef = useRef<HTMLImageElement>(null);

    useEffect(() => {
        if (imgRef.current && imgRef.current.complete) {
            setLoaded(true);
        }
    }, [src]);

    const handleImageLoad = () => {
        setLoaded(true);
    };

    return (
        <div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden' }}>
            {(!loaded || src === undefined) && (
                <Skeleton height="100%" width="100%" animate={true} radius={0} p={0} />
            )}
            <Image
                ref={imgRef}
                src={src}
                alt={alt}
                fit="cover"
                height="100%"
                width="100%"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    opacity: loaded ? 1 : 0,
                    transition: 'opacity 0.3s ease-in-out',
                    cursor: 'pointer',
                }}
                onLoad={handleImageLoad}
                onClick={onClick}
            />
        </div>
    );
});

export default ImageWithSkeleton;